import React from 'react';
import { Map, GoogleApiWrapper, Marker } from 'google-maps-react';
import snazzyMapStyles from './snazzyMapStyles';
import pin from '../../../assets/icons/pin50.svg';

const mapStyles = {
  width: '50%',
  height: '100%',
};

const coordinates = {
  lat: 46.62,
  lng: 26.07,
  zoom: 8,
};

const MapComponent = (props) => {
  const locations = props.locations;
  const style = props.mapClasses ? {} : props.mapStyles || mapStyles;
  return (
    <>
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2799.438698757229!2d28.0249185!3d45.44081509999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40b6de8a76f229c7%3A0xd000b49b02c3dd13!2sStrada%20Clabucet%203%2C%20Gala%C8%9Bi!5e0!3m2!1sen!2sro!4v1699959177197!5m2!1sen!2sro"
        width="100%"
        height="450"
      ></iframe>
      {/* <Map
        className={props.mapClasses}
        google={props.google}
        zoom={props.coordinates?.zoom || coordinates.zoom}
        style={style}
        initialCenter={props.coordinates || coordinates}
        styles={snazzyMapStyles}
      >
        {locations &&
          locations.map((loc, idx) => (
            <Marker
              key={`${loc.location.lat}.${idx}`}
              position={loc.location}
              onClick={() => props.onMarkerClick(loc)}
              icon={pin}
            />
          ))}
      </Map> */}
    </>
  );
};
export default GoogleApiWrapper((props) => ({
  apiKey: window.__APP_CONFIG__.gmapsApiKey,
  language: 'RO',
  ...props,
}))(MapComponent);
